<div class="flex flex-row flex-wrap gap-3" [formGroup]="settingsForm">
  <div class="flex align-items-end">
    <div>
      <label class="block font-bold mb-2" for="control">Control</label>
      <input
        inputId="control"
        type="text"
        pInputText
        class="w-full p-inputtext"
        [disabled]="true"
        [value]="control"
      />
    </div>
    <p-button (onClick)="addControl()" class="ml-2">Select Control</p-button>
  </div>
  <div>
    <label class="block font-bold mb-2" for="name">Name</label>
    <input
      inputId="name"
      formControlName="name"
      type="text"
      pInputText
      class="w-full p-inputtext"
    />
  </div>
  <div>
    <label class="block font-bold mb-2" for="description">Description</label>
    <input
      inputId="description"
      formControlName="weaknessDescription"
      type="text"
      pInputText
      class="w-full p-inputtext"
    />
  </div>
  <div>
    <label class="block font-bold mb-2" for="howIdentified"
      >How Identified</label
    >
    <input
      inputId="howIdentified"
      formControlName="howIdentified"
      type="text"
      pInputText
      class="w-full p-inputtext"
    />
  </div>
  <div>
    <label class="block font-bold mb-2" for="responsibleParty"
      >Responsible Party</label
    >
    <input
      inputId="responsibleParty"
      formControlName="responsibleParty"
      type="text"
      pInputText
      class="w-full p-inputtext"
    />
  </div>
  <div>
    <label class="block font-bold mb-2" for="identificationDate"
      >Date of Identification</label
    >
    <p-datepicker
      inputId="identificationDate"
      formControlName="identificationDate"
      showIcon="true"
      dataType="string"
      dateFormat="mm/dd/yy"
      required="true"
    >
    </p-datepicker>
  </div>
  <div>
    <label class="block font-bold mb-2" for="scheduledCompletionDate"
      >Scheduled Completion Date</label
    >
    <p-datepicker
      inputId="scheduledCompletionDate"
      formControlName="scheduledCompletionDate"
      showIcon="true"
      dataType="string"
      dateFormat="mm/dd/yy"
      required="true"
    >
    </p-datepicker>
  </div>
  <div>
    <label class="block font-bold mb-2" for="actualCompletionDate"
      >Actual Completion Date</label
    >
    <p-datepicker
      inputId="actualCompletionDate"
      formControlName="actualCompletionDate"
      showIcon="true"
      dataType="string"
      dateFormat="mm/dd/yy"
      required="true"
    >
    </p-datepicker>
  </div>
  <div>
    <label class="block font-bold mb-2" for="currentStatus"
      >Current Status</label
    >
    <p-select
      inputId="currentStatus"
      [options]="currentStatusOptions"
      formControlName="currentStatus"
      optionLabel="name"
      optionValue="value"
      showClear="true"
      placeholder="Select Current Status"
    ></p-select>
  </div>
  <div>
    <label class="block font-bold mb-2" for="riskLevel">Risk Level</label>
    <p-select
      inputId="riskLevel"
      [options]="riskLevelOptions"
      formControlName="riskLevel"
      showClear="true"
      placeholder="Select Risk Level"
    ></p-select>
  </div>
  <div>
    <label class="block font-bold mb-2" for="remediation"
      >Remediation Plans, Actions and Milestones</label
    >
    <input
      inputId="remediation"
      formControlName="remediationPlansActionsMilestones"
      type="text"
      pInputText
      class="w-full p-inputtext"
    />
  </div>
  <div>
    <label class="block font-bold mb-2" for="changeRemediation"
      >Changes to Remediation Plans, Actions, and Milestones (if
      applicable)</label
    >
    <input
      inputId="changeRemediation"
      formControlName="changesToRemediationPlansActionsMilestones"
      type="text"
      pInputText
      class="w-full p-inputtext"
    />
  </div>
  <div>
    <label class="block font-bold mb-2" for="comments">Comments</label>
    <input
      inputId="comments"
      formControlName="comments"
      type="text"
      pInputText
      class="w-full p-inputtext"
    />
  </div>
</div>
